import { StyledLabel } from './ToggleSwitch.styled'

type Props = {
  checked: boolean
  onChange: () => void
  id?: string
}

/**
 * Controlled Toggle Switch. This switch expects to be controlled with
 * outside state (inversion of control) to make it Flexible
 */
export const ToggleSwitch = ({ checked, onChange, id }: Props) => {
  return (
    <StyledLabel htmlFor='checkbox' checked={checked}>
      <input id={id ?? 'checkbox'} type='checkbox' checked={checked} onChange={onChange} />
    </StyledLabel>
  )
}
